module.exports = __webpack_public_path__ + "img/auth.ab949c50.svg";